module.exports = {"id":"s1-q1","text":"Are you currently employed, or have you had a job in the past 5 years?","multiselect":false,"options":[{"id":"s1-q1-a1","text":"Yes","next":"s1-q2","baseline":4,"capability":0,"access":0},{"id":"s1-q1-a2","text":"No","next":"s2-q1","capability":0,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s1-q1.json
// module id = 887
// module chunks = 41